<mat-card>
  <mat-card-content>
    <div class="table-responsive-simpli add_factoring">
      <table mat-table [dataSource]="dataSource">

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef class="custom-header">Fecha</th>
          <td mat-cell *matCellDef="let element" [ngClass]="{'blur-effect': loading}">
            <input type="text" class="no-input" readonly 
                   [value]="loading ? '$00.000.000' : element.date">
          </td>
        </ng-container>
        
        <ng-container matColumnDef="inversionInicial">
          <th mat-header-cell *matHeaderCellDef class="custom-header">Inversión inicial</th>
          <td mat-cell *matCellDef="let element" [ngClass]="{'blur-effect': loading}">
            <input type="text" class="no-input" readonly 
                   [value]="loading ? '$00.000.000' : ('$' + (element.inversionInicial | formatting:'money'))">
          </td>
        </ng-container>
        
        <ng-container matColumnDef="inversionFinal">
          <th mat-header-cell *matHeaderCellDef class="custom-header">Inversión final</th>
          <td mat-cell *matCellDef="let element" [ngClass]="{'blur-effect': loading}">
            <input type="text" class="no-input" readonly 
                   [value]="loading ? '$00.000.000' : ('$' + (element.inversionFinal | formatting:'money'))">
          </td>
        </ng-container>
        
        <ng-container matColumnDef="simpli">
          <th mat-header-cell *matHeaderCellDef class="custom-header">Simpli</th>
          <td mat-cell *matCellDef="let element" [ngClass]="{'blur-effect': loading}">
            <input type="text" class="no-input" readonly 
                   [value]="loading ? '$00.000.000' : ('$' + (element.simpli | formatting:'money'))">
          </td>
        </ng-container>
        
        <ng-container matColumnDef="dap">
          <th mat-header-cell *matHeaderCellDef class="custom-header">DAP</th>
          <td mat-cell *matCellDef="let element" [ngClass]="{'blur-effect': loading}">
            <input type="text" class="no-input" readonly 
            [value]="loading ? '$00.000.000' : ('$' + (element.dap | formatting:'money'))">
          </td>
        </ng-container>
        
        <ng-container matColumnDef="rentabilidadSimpli">
          <th mat-header-cell *matHeaderCellDef class="custom-header">Rentabilidad Simpli</th>
          <td mat-cell *matCellDef="let element" [ngClass]="{'blur-effect': loading}">
            <input type="text" class="no-input textGreen" readonly 
                   [value]="loading ? '$00.000.000' : (element.rentabilidadSimpli + '%')">
          </td>
        </ng-container>
        
        
        

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
